// useSession.ts — hook React de leitura do AuthContext.
//
// Uso:
//   const { user, status, signOut } = useSession();
//   if (status === 'loading') return <Skeleton />;
//   if (status === 'unauthenticated') return <Navigate to="/login" />;
//   return <p>Hello, {user.name}</p>;

import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from '@/lib/auth/AuthContext';

export function useSession(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useSession deve ser usado dentro de <AuthProvider>.');
  }
  return ctx;
}

/** Conveniência: retorna true se o user pertence a qualquer um dos grupos. */
export function hasGroup(groups: string[] | undefined, ...allowed: string[]): boolean {
  if (!groups || groups.length === 0) return false;
  return allowed.some((g) => groups.includes(g));
}
